import { useSyncExternalStore } from 'react'
import { RefreshCw } from 'lucide-react'
import { subscribe, isUpdatePending, applyUpdate } from '../lib/appUpdate.js'

/**
 * "New version ready" — only ever seen when an update arrived at a moment it
 * would have been rude to reload (mid-typing, editor open). Otherwise the app
 * switches by itself and this never renders. Navy: it's a primary action, not
 * an alarm. Sits above the tab bar and clear of the iPhone home indicator.
 */
export default function UpdateBanner() {
  const pending = useSyncExternalStore(subscribe, isUpdatePending)
  if (!pending) return null
  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-40 flex justify-center px-4"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 76px)' }}
    >
      <button
        type="button"
        onClick={applyUpdate}
        className="tap pointer-events-auto flex items-center gap-2 rounded-full bg-navy px-4 py-2 text-sm font-medium text-white shadow-lg active:opacity-80"
      >
        <RefreshCw size={15} />
        New version ready · Reload
      </button>
    </div>
  )
}
